/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Playground_DetailInputs */

const en_common_header_ai_playground_detail = /** @type {(inputs: Common_Header_Ai_Playground_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try directory models`)
};

const zh_common_header_ai_playground_detail = /** @type {(inputs: Common_Header_Ai_Playground_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用目录模型`)
};

/**
* | output |
* | --- |
* | "Try directory models" |
*
* @param {Common_Header_Ai_Playground_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_playground_detail = /** @type {((inputs?: Common_Header_Ai_Playground_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Playground_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_playground_detail(inputs)
	return zh_common_header_ai_playground_detail(inputs)
});
export { common_header_ai_playground_detail as "common.header.ai.playground.detail" }